import {HttpService} from "../http/HttpService";
import {Settings} from "../http/Types";
import {AdminUserService} from "../services/AdminUserService";
import {UserAuthenticationService} from "../services/UserAuthenticationService";
import {MenuService} from "../services/MenuService";
import {UserGroupService} from "../services/UserGroupService";
import {UserAttributeService} from "../services/UserAttributeService";
import {UserService} from "../services/UserService";
import {TicketService} from "../services/TicketService";
import {ChartService} from "../services/ChartService";
import {WalletService} from "../services/WalletService";
import {MultiBalanceService} from "../services/MultiBalanceService";
import {AccountService} from "../services/AccountService";
import {TransactionEntriesService} from "../services/TransactionEntriesService";

import {CasinoCategoryService} from "../services/CasinoCategoryService";
import {CasinoGameService} from "../services/CasinoGameService";

import {PaymentService} from "../services/PaymentService";
import {AdminNotesService} from "../services/AdminNotesService";
import {MetricsService} from "../services/MetricsService";
import {SettingsService} from "../services/SettingsService";
import { BundleService } from "../services/BundleService";
import {InternalSettingsService} from "../services/InternalSettingsService";
import {AffiliatesService} from "../services/AffiliatesService";
import {ProviderService} from "../services/ProviderService";
import {AffiliatesPaymentService} from "../services/AffiliatesPaymentService";
import {CasinoStudioService} from "../services/CasinoStudioService";
import {CasinoGameTagService} from "../services/CasinoGameTagService";
import {TranslationsService} from "../services/TranslationsService";
import {NotificationsService} from "../services/NotificationsService";
import {BatchTransactionService} from "../services/BatchTransactionService";
import {MetabaseService} from "../services/MetabaseService";
import {TurnoverContributionsService} from "../services/TurnoverContributionsService";
import {OfferRuleService} from "../services/OfferRuleService";
import {MonetaryConfigService} from "../services/MonetaryConfigService";
import {BonusConfigService} from "../services/BonusConfigService";
import {BonusOfferService} from "../services/BonusOfferService";
import {UserBonusService} from "../services/UserBonusService";
import {AuditLogService} from "../services/AuditLogService";
import { AnalyticsService } from "../services/AnalyticsService";
import {SystemEventService} from "../services/SystemEventService";
import { UserLabelService } from "../services/UserLabelService";
import {UserBonusEventService} from "../services/UserBonusEventService";

import { ContestsService } from "../services/ContestsService";
import { ContestTypesService } from "../services/ContestTypesService";

import { BonusSettingLimitService } from "../services/BonusSettingLimitService";
import { CreditService } from "../services/CreditService";

import { SportBetsService } from "../services/SportsBetsService";
import { SportsBetLogsService } from "../services/SportsBetLogsService";
import { PaymentSettingService } from "../services/PaymentSettingService";
import { PaymentProviderService } from "../services/PaymentProviderService";

var container : AppContext;

interface AppContext {
    getSettings() : Settings;
    getHttpService() : HttpService;
    getProviderService(): ProviderService;
    getAdminUserService() : AdminUserService;
    getUserAuthenticationService() : UserAuthenticationService;
    getMenuService() : MenuService;
    getUserGroupService() : UserGroupService;
    getUserAttributeService(): UserAttributeService;
    getUserService() : UserService;
    getTicketService(): TicketService;
    getChartService() : ChartService;
    getWalletService() : WalletService;
    getMultiBalanceService() : MultiBalanceService;
    getAccountService() : AccountService;
    getCreditService() : CreditService;
    getAuditLogService() : AuditLogService;
    getTransactionEntriesService() : TransactionEntriesService;
    getCasinoCategoryService() : CasinoCategoryService;
    getCasinoGameService() : CasinoGameService;
    getPaymentService() : PaymentService;
    getAdminNotesService() : AdminNotesService;
    getAnalyticsService(): AnalyticsService;
    getMetricsService() : MetricsService;
    getSettingsService() : SettingsService;
    getInternalSettingsService() : InternalSettingsService;
    getBundleService() : BundleService;
    getAffiliatesService() : AffiliatesService;
    getAffiliatesPaymentService() : AffiliatesPaymentService;
    getCasinoStudioService() : CasinoStudioService;
    getCasinoGameTagService() : CasinoGameTagService;
    getTranslationsService() : TranslationsService;
    getNotificationsService() : NotificationsService;
    getBatchTransactionService() : BatchTransactionService;
    getMetabaseService() : MetabaseService;
    getTurnoverContributionsService() : TurnoverContributionsService;
    getOfferRuleService() : OfferRuleService;
    getMonetaryConfigService() : MonetaryConfigService;
    getBonusConfigService() : BonusConfigService;
    getBonusOfferService() : BonusOfferService;
    getUserBonusService() : UserBonusService;
    getSystemEventService() : SystemEventService;
    getUserLabelService() : UserLabelService;
    getUserBonusEventService() : UserBonusEventService;
    getContestsService() : ContestsService;
    getContestTypesService() : ContestTypesService;
    getBonusSettingLimitService(): BonusSettingLimitService;
    getSportBetsService(): SportBetsService;
    getSportsBetLogsService(): SportsBetLogsService;
    getPaymentSettingService(): PaymentSettingService;
    getPaymentProviderService(): PaymentProviderService;
}
export function wireApplication(settings : Settings) {
    let httpService = new HttpService(settings.baseUrl);
    let providerService = new ProviderService(settings.cubeiaDashboardBaseUrl, settings.integrationBackOffices, settings.enabledPaymentProviders);
    let adminUserService = new AdminUserService(httpService);
    let userAuthService = new UserAuthenticationService(httpService);
    let menuService = new MenuService(httpService);
    let userGroupService = new UserGroupService(httpService);
    let userAttributeService = new UserAttributeService(httpService);
    let userService = new UserService(httpService);
    let ticketService = new TicketService(httpService);
    let chartService = new ChartService(httpService);
    let walletService = new WalletService(httpService);
    let multiBalanceService = new MultiBalanceService(httpService);
    let accountService = new AccountService(httpService);
    let creditService = new CreditService(httpService);
    let auditLogService = new AuditLogService(httpService);
    let transactionEntriesService = new TransactionEntriesService(httpService);
    let casinoCategoryService = new CasinoCategoryService(httpService);
    let casinoGameServie = new CasinoGameService(httpService);
    let paymentService = new PaymentService(httpService);
    let adminNotesService = new AdminNotesService(httpService);
    let analyticsService = new AnalyticsService(httpService);
    let metricsService = new MetricsService(httpService);
    let settingsService = new SettingsService(httpService);
    let internalSettingsService = new InternalSettingsService(httpService);
    let bundleService = new BundleService(httpService);
    let affiliatesService = new AffiliatesService(httpService);
    let affiliatesPaymentService = new AffiliatesPaymentService(httpService);
    let casinoStudioService = new CasinoStudioService(httpService);
    let casinoGameTagService = new CasinoGameTagService(httpService);
    let translationsService = new TranslationsService(httpService);
    let notificationsService =  new NotificationsService(httpService);
    let batchTransactionService = new BatchTransactionService(httpService);
    let metabaseService = new MetabaseService(httpService);
    let turnoverContributionsService = new TurnoverContributionsService(httpService);
    let offerRuleService = new OfferRuleService(httpService);
    let monetaryConfigService = new MonetaryConfigService(httpService);
    let bonusConfigService = new BonusConfigService(httpService);
    let bonusOfferService = new BonusOfferService(httpService);
    let userBonusService = new UserBonusService(httpService);
    let systemEventService = new SystemEventService(httpService);
    let userLabelService = new UserLabelService(httpService);
    let userBonusEventService = new UserBonusEventService(httpService);
    let contestsService = new ContestsService(httpService);
    let contestTypesService = new ContestTypesService(httpService);
    let bonusSettingLimitService = new BonusSettingLimitService(httpService);
    let sportBetsService = new SportBetsService(httpService);
    let sportsBetLogsService = new SportsBetLogsService(httpService);
    let paymentSettingService = new PaymentSettingService(httpService);
    let paymentProviderService = new PaymentProviderService(httpService);
    container = {
        getSettings: () => settings,
        getBonusOfferService(): BonusOfferService {
            return bonusOfferService;
        },
        getBonusConfigService(): BonusConfigService {
            return bonusConfigService;
        },
        getMonetaryConfigService(): MonetaryConfigService {
            return monetaryConfigService;
        }, getOfferRuleService(): OfferRuleService {
            return offerRuleService;
        },
        getHttpService: () => httpService,
        getProviderService: () => providerService,
        getAdminUserService: () => adminUserService,
        getUserAuthenticationService: () => userAuthService,
        getMenuService: () => menuService,
        getUserGroupService: () => userGroupService,
        getUserAttributeService: () => userAttributeService,
        getUserService: () => userService,
        getTicketService: () => ticketService,
        getChartService: () => chartService,
        getWalletService: () => walletService,
        getMultiBalanceService: () => multiBalanceService,
        getAccountService : () => accountService,
        getCreditService : () => creditService,
        getAuditLogService : () => auditLogService,
        getTransactionEntriesService: () => transactionEntriesService,
        getCasinoCategoryService : () => casinoCategoryService,
        getCasinoGameService : () => casinoGameServie,
        getPaymentService: () => paymentService,
        getAdminNotesService : () => adminNotesService,
        getAnalyticsService: () => analyticsService,
        getMetricsService: () => metricsService,
        getSettingsService: () => settingsService,
        getInternalSettingsService: () => internalSettingsService,
        getBundleService: () => bundleService,
        getAffiliatesService: () => affiliatesService,
        getAffiliatesPaymentService: () => affiliatesPaymentService,
        getCasinoStudioService : () => casinoStudioService,
        getCasinoGameTagService : () => casinoGameTagService,
        getTranslationsService : () => translationsService,
        getNotificationsService : () => notificationsService,
        getBatchTransactionService : () => batchTransactionService,
        getMetabaseService : () => metabaseService,
        getTurnoverContributionsService : () => turnoverContributionsService,
        getUserBonusService : () => userBonusService,
        getSystemEventService : () => systemEventService,
        getUserLabelService: () => userLabelService,
        getUserBonusEventService : () => userBonusEventService,
        getContestsService : () => contestsService,
        getContestTypesService: () => contestTypesService,
        getBonusSettingLimitService: () => bonusSettingLimitService,
        getSportBetsService: () => sportBetsService,
        getSportsBetLogsService: () => sportsBetLogsService,
        getPaymentSettingService: () => paymentSettingService,
        getPaymentProviderService: () => paymentProviderService
    }
}

export function getContainer() : AppContext {
    return container;
}